import Frame from "../components/Frame";
import ResetTablet from "../components/ResetTablet";
import ui from "../components/ui.module.css";

// Adult-facing, in the Teacher App's message-card style.
const COPY = {
  "not-enrolled": {
    title: "Learner not found in this class",
    body: "The learner this tablet was set up for is no longer in this class. Reset the tablet and set it up again for the right learner.",
  },
  "no-access": {
    title: "This tablet can't open the learner screen",
    body: "This tablet isn't allowed to open this learner's class or work. Reset the tablet and set it up again with a new code.",
  },
  // Setting the tablet up again cannot fix this one, so it does not offer to.
  "release-unavailable": {
    title: "Learner tablets aren't set up yet",
    body: "This tablet can't tell whether a teacher has sent an activity to it. That part of Thuto Time still has to be set up. Ask whoever manages Thuto Time to finish setting up learner tablets.",
    resettable: false,
  },
  // Resetting cannot fix an old browser, so it is not offered.
  "unsupported-device": {
    title: "This tablet's browser is too old for this activity",
    body: "Update the tablet's browser, then check again: Chrome 67 or later on Android, or iPadOS 14 or later on an iPad.",
    resettable: false,
  },
  unreadable: {
    title: "The activity can't be shown",
    body: "Part of the activity is missing or not in the expected form. Ask whoever manages Thuto Time to check it.",
  },
};

const NotReady = ({ reason, onRecheck, onReset }) => {
  const copy = COPY[reason] || COPY.unreadable;
  return (
    <Frame narrow>
      <div className={`${ui.card} ${ui.stack}`} role="status">
        <h1 className={ui.cardTitle}>{copy.title}</h1>
        <p className={ui.meta}>{copy.body}</p>
        <button
          type="button"
          className={`${ui.button} ${ui.primary}`}
          onClick={onRecheck}
        >
          Check again
        </button>
        {onReset && copy.resettable !== false && <ResetTablet onReset={onReset} />}
      </div>
    </Frame>
  );
};

export default NotReady;
